import React, { useState } from "react";

const Prompts = ({ onPositivePromptChange, onNegativePromptChange, onRoomSelect, onDesignSelect }) => {
  const [positivePrompt, setPositivePrompt] = useState("");
  const [negativePrompt, setNegativePrompt] = useState("");

  const extractCorePrompt = (prompt) => {
    const cleanPrompt = prompt.replace(
      /(best quality:1\.4|masterpiece:1\.4|photorealistic:1\.4|ultra high res, raw photo:1\.4|hdr, hyperdetailed:1\.2|8K:1\.2|real|realistic|super detailed|4k|8k|interior),*/g,
      ""
    ).trim();
    return cleanPrompt.replace(/[\(\)]/g, "").trim();
  };

  const addTechnicalParameters = (prompt) => {
    return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
  };

  const handleRoomSelect = (selectedItem) => {
    const corePositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
    const coreNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);
    setPositivePrompt(corePositivePrompt);
    setNegativePrompt(coreNegativePrompt);
    onRoomSelect(addTechnicalParameters(selectedItem.positivePrompt), addTechnicalParameters(selectedItem.negativePrompt));
  };

  const handleDesignSelect = (selectedItem) => {
    const designPositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
    const designNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);

    setPositivePrompt((prev) => {
      const currentPrompt = extractCorePrompt(prev);
      return currentPrompt ? `${currentPrompt}, ${designPositivePrompt}` : designPositivePrompt;
    });

    setNegativePrompt((prev) => {
      const currentPrompt = extractCorePrompt(prev);
      return currentPrompt ? `${currentPrompt}, ${designNegativePrompt}` : designNegativePrompt;
    });

    onDesignSelect(addTechnicalParameters(selectedItem.positivePrompt), addTechnicalParameters(selectedItem.negativePrompt));
  };

  const validatePrompts = () => {
    if (!positivePrompt.trim()) {
      return false;
    }
    return true;
  };

  return {
    positivePrompt,
    negativePrompt,
    setPositivePrompt,
    setNegativePrompt,
    handleRoomSelect,
    handleDesignSelect,
    validatePrompts,
    addTechnicalParameters,
  };
};

export default Prompts;

// import React, { useState } from "react";

// const Prompts = ({ onPositivePromptChange, onNegativePromptChange, onRoomSelect, onDesignSelect }) => {
//   const [userPositivePrompt, setUserPositivePrompt] = useState(""); // Only for user input
//   const [userNegativePrompt, setUserNegativePrompt] = useState(""); // Only for user input
//   const [internalPositivePrompt, setInternalPositivePrompt] = useState(""); // Stores room+design prompts
//   const [internalNegativePrompt, setInternalNegativePrompt] = useState(""); // Stores room+design prompts

//   const addTechnicalParameters = (prompt) => {
//     return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
//   };

//   const handleRoomSelect = (selectedItem) => {
//     // Store room prompts internally without displaying
//     setInternalPositivePrompt(selectedItem.positivePrompt);
//     setInternalNegativePrompt(selectedItem.negativePrompt);
    
//     if (onRoomSelect) onRoomSelect(
//       addTechnicalParameters(selectedItem.positivePrompt), 
//       selectedItem.negativePrompt
//     );
//   };

//   const handleDesignSelect = (selectedItem) => {
//     // Append design prompts internally without displaying
//     setInternalPositivePrompt(prev => 
//       prev ? `${prev}, ${selectedItem.positivePrompt}` : selectedItem.positivePrompt
//     );
//     setInternalNegativePrompt(prev => 
//       prev ? `${prev}, ${selectedItem.negativePrompt}` : selectedItem.negativePrompt
//     );
    
//     if (onDesignSelect) onDesignSelect(
//       addTechnicalParameters(selectedItem.positivePrompt), 
//       selectedItem.negativePrompt
//     );
//   };

//   const getFullPositivePrompt = () => {
//     const basePrompt = internalPositivePrompt || "";
//     const userPrompt = userPositivePrompt || "";
    
//     const combined = [basePrompt, userPrompt]
//       .filter(Boolean)
//       .join(", ");
      
//     return combined ? addTechnicalParameters(combined) : "";
//   };
  
//   const getFullNegativePrompt = () => {
//     const basePrompt = internalNegativePrompt || "";
//     const userPrompt = userNegativePrompt || "";
    
//     return [basePrompt, userPrompt]
//       .filter(Boolean)
//       .join(", ");
//   };

//   const validatePrompts = () => {
//     // Only check for internal prompts (room+design), ignore user input for validation
//     return !!internalPositivePrompt;
//   };

//   return {
//     positivePrompt: userPositivePrompt, // Only shows user input
//     negativePrompt: userNegativePrompt, // Only shows user input
//     setPositivePrompt: setUserPositivePrompt,
//     setNegativePrompt: setUserNegativePrompt,
//     handleRoomSelect,
//     handleDesignSelect,
//     validatePrompts,
//     getFullPositivePrompt,
//     getFullNegativePrompt,
//   };
// };

// export default Prompts;





// import React, { useState } from "react";

// const Prompts = ({ onPositivePromptChange, onNegativePromptChange, onRoomSelect, onDesignSelect }) => {
//   const [positivePrompt, setPositivePrompt] = useState("");
//   const [negativePrompt, setNegativePrompt] = useState("");

//   const extractCorePrompt = (prompt) => {
//     const cleanPrompt = prompt.replace(
//       /(best quality:1\.4|masterpiece:1\.4|photorealistic:1\.4|ultra high res, raw photo:1\.4|hdr, hyperdetailed:1\.2|8K:1\.2|real|realistic|super detailed|4k|8k|interior),*/g,
//       ""
//     ).trim();
//     return cleanPrompt.replace(/[\(\)]/g, "").trim();
//   };

//   const addTechnicalParameters = (prompt) => {
//     return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
//   };

//   const getFullPositivePrompt = () => {
//     return addTechnicalParameters(positivePrompt);
//   };

//   const getFullNegativePrompt = () => {
//     return negativePrompt; // No technical params added to negative prompt
//   };

//   const handleRoomSelect = (selectedItem) => {
//     const corePositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
//     const coreNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);
//     setPositivePrompt(corePositivePrompt);
//     setNegativePrompt(coreNegativePrompt);
//     if (onRoomSelect) onRoomSelect(
//       addTechnicalParameters(selectedItem.positivePrompt), 
//       addTechnicalParameters(selectedItem.negativePrompt)
//     );
//   };

//   const handleDesignSelect = (selectedItem) => {
//     const designPositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
//     const designNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);

//     setPositivePrompt((prev) => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designPositivePrompt}` : designPositivePrompt;
//     });

//     setNegativePrompt((prev) => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designNegativePrompt}` : designNegativePrompt;
//     });

//     if (onDesignSelect) onDesignSelect(
//       addTechnicalParameters(selectedItem.positivePrompt), 
//       addTechnicalParameters(selectedItem.negativePrompt)
//     );
//   };

//   const validatePrompts = () => {
//     if (!positivePrompt.trim()) {
//       return false;
//     }
//     return true;
//   };

//   return {
//     positivePrompt,
//     negativePrompt,
//     setPositivePrompt,
//     setNegativePrompt,
//     handleRoomSelect,
//     handleDesignSelect,
//     validatePrompts,
//     addTechnicalParameters,
//     getFullPositivePrompt,
//     getFullNegativePrompt,
//   };
// };

// export default Prompts;




// import React, { useState } from "react";

// const Prompts = ({ onPositivePromptChange, onNegativePromptChange, onRoomSelect, onDesignSelect }) => {
//   const [positivePrompt, setPositivePrompt] = useState("");
//   const [negativePrompt, setNegativePrompt] = useState("");

//   const extractCorePrompt = (prompt) => {
//     const cleanPrompt = prompt.replace(
//       /(best quality:1\.4|masterpiece:1\.4|photorealistic:1\.4|ultra high res, raw photo:1\.4|hdr, hyperdetailed:1\.2|8K:1\.2|real|realistic|super detailed|4k|8k|interior),*/g,
//       ""
//     ).trim();
//     return cleanPrompt.replace(/[\(\)]/g, "").trim();
//   };

//   const addTechnicalParameters = (prompt) => {
//     return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
//   };

//   const handleRoomSelect = (selectedItem) => {
//     const corePositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
//     const coreNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);
//     setPositivePrompt(corePositivePrompt);
//     setNegativePrompt(coreNegativePrompt);
//     onRoomSelect(addTechnicalParameters(selectedItem.positivePrompt), addTechnicalParameters(selectedItem.negativePrompt));
//   };

//   const handleDesignSelect = (selectedItem) => {
//     const designPositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
//     const designNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);

//     setPositivePrompt((prev) => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designPositivePrompt}` : designPositivePrompt;
//     });

//     setNegativePrompt((prev) => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designNegativePrompt}` : designNegativePrompt;
//     });

//     onDesignSelect(addTechnicalParameters(selectedItem.positivePrompt), addTechnicalParameters(selectedItem.negativePrompt));
//   };

//   const validatePrompts = () => {
//     if (!positivePrompt.trim()) {
//       return false;
//     }
//     return true;
//   };

//   return {
//     positivePrompt,
//     negativePrompt,
//     setPositivePrompt,
//     setNegativePrompt,
//     handleRoomSelect,
//     handleDesignSelect,
//     validatePrompts,
//     addTechnicalParameters,
//   };
// };

// export default Prompts;
